import API from '../api'

// Registration
export const signup =  async (userPayload) => {
    const res = await API.post("/auth/signup",userPayload)
    return res.data
}

// Login
export const loginUser = async (email, password) => {
  const res = await API.post("/auth/login", { email, password });
  return res.data;
};

// Get current user (protected route)
export const getCurrentUser = async () => {
  const res = await API.get("/auth/me");
  return res.data;
};

// Logout
export const logoutUser = async () => {
  const res = await API.post("/auth/logout")
  localStorage.removeItem("access_token")
  return res.data
};

// change password
export const forgotPassword = async (email) => {
  return API.post("/auth/forgot-password", { email });
};
